import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getDraftOrPublishedSchedules = api(async function getDraftOrPublishedSchedules({
    projectId,
    scheduleIds,
}) {
    if (!projectId || !scheduleIds || !scheduleIds?.length) return null
    return query(
        gql`
            query GetDraftOrPublishedSchedules($projectId: String!, $scheduleIds: [String!]!) {
                getDraftOrPublishedSchedules(projectId: $projectId, scheduleIds: $scheduleIds) {
                    id
                    _id
                    isDraft
                    status
                    reviewCycle
                    seedSource
                    creationType
                    publishedId
                    title
                    code
                    unitOfMeasure
                    version
                    metadata {
                        published
                    }
                    intro {
                        content
                        note
                    }
                    tasks {
                        id
                        content
                        title
                        note
                        isHeader
                        minutes
                        taskId
                        headerTaskId
                        classification
                        componentRef
                        linkedFields
                        frequency {
                            period
                            interval
                        }
                        skillSet
                        unitOfMeasure
                    }
                    legislation
                }
            }
        `,
        { projectId, scheduleIds },
        { returns: "getDraftOrPublishedSchedules" }
    )
})
